import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronRightXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5.70006 4.23878C5.9642 3.95444 6.39783 3.92202 6.70104 4.15089L10.2606 7.44972C10.4133 7.59157 10.4998 7.79112 10.4999 7.99953C10.4999 8.20803 10.4134 8.40743 10.2606 8.54933L6.76061 11.7993C6.45711 12.0811 5.98192 12.0637 5.70006 11.7603C5.4185 11.4568 5.43579 10.9815 5.73912 10.6997L8.64635 7.99953L5.68639 5.24367C5.43566 4.95818 5.43592 4.52324 5.70006 4.23878Z",
            fill: color
        })
    });

//# sourceMappingURL=chevron-right-xs.js.map